export default __webpack_public_path__ + "static/media/11.1a23e457.jpg";